import React from 'react';

const Page404 = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80%',
      }}
    >
      <h1>404</h1>
    </div>
  );
};

export default Page404;
